import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { ROMAN_SLUG } from './memoryUtils';
import './ProjectionPage.css';

export default function ProjectionPage() {
  const { profileSlug } = useParams();
  const [error, setError] = useState('');
  useEffect(() => {
    const controller = new AbortController();
    const open = async () => {
      const response = await fetch(`/api/profiles/slug/${profileSlug || ROMAN_SLUG}`, { signal: controller.signal });
      if (!response.ok) throw new Error('Profil se nepodařilo načíst.');
      const profile = await response.json();
      const pairing = await fetch(`/api/profiles/${profile.id}/projection-player`, { signal: controller.signal });
      if (!pairing.ok) throw new Error('Projekci se nepodařilo načíst.');
      const { code } = await pairing.json();
      if (code && !controller.signal.aborted) {
        const url = new URL('/player/', location.origin);
        url.searchParams.set('code', code);
        url.searchParams.set('server', location.origin);
        location.replace(url.href);
      }
    };
    open().catch((failure) => {
      if (failure.name !== 'AbortError') setError(failure.message);
    });
    return () => controller.abort();
  }, [profileSlug]);
  return (
    <main className="projection-idle">
      <h1>Projekce neběží</h1>
      {error && <p role="alert">{error}</p>}
    </main>
  );
}
